module.exports = __webpack_public_path__ + "static/sonia_before-ad2c5f3ac691f47a9a013056af315c16.png";